import React from 'react';

interface DownArrowProps{
  className?: string;
  color?:string
}

const DownArrow: React.FC<DownArrowProps> = ({
  className,
  color="#1E2F56"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
    <path d="M9.96004 4.4751L6.70004 7.7351C6.31504 8.1201 5.68504 8.1201 5.30004 7.7351L2.04004 4.4751" stroke={color} stroke-miterlimit="10" strokeLinecap="round" stroke-linejoin="round"/>
  </svg>
  );
};

export default DownArrow;